// EnrichingLivesSection.js
import React from "react";
import { Phone } from "lucide-react";
import enrichingLivesImage from "../assets/enriching-lives-image.jpg";

const EnrichingLivesSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Enriching Lives through Compassionate and Engaging Companion Care
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                At Allawah Lodge, we believe that companion care goes beyond
                providing basic support—it is about creating meaningful
                connections and enriching the lives of our clients. Our
                dedicated caregivers are trained to provide compassionate and
                engaging companion care that enhances overall well-being and
                fosters a sense of joy, purpose, and fulfillment.
              </p>

              <p>
                Companion care is designed to address the social and emotional
                needs of individuals who may be experiencing loneliness,
                isolation, or a decrease in social interactions. Our caregivers
                are more than just companions; they become trusted friends who
                are there to listen, offer support, and engage in meaningful
                conversations. They provide a comforting presence, creating a
                sense of belonging and reducing feelings of isolation.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={enrichingLivesImage}
              alt="Young woman embracing elderly man"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnrichingLivesSection;
